<template>
  <div>
    <span class="site-warning site-warning-all">
      {{ $t('com_fault_all') }}
      {{
        isOK
          ? listStatus[record.info.stationId]['cas'] +
            listStatus[record.info.stationId]['mas'] +
            listStatus[record.info.stationId]['oas']
          : '0'
      }}
    </span>
    <span
      class="site-warning site-warning-ca"
      v-if="isOK && listStatus[record.info.stationId]['cas'] > 0"
    >
      {{ $t('com_fault_ca') }}
      {{ listStatus[record.info.stationId]['cas'] }}
    </span>
    <span
      class="site-warning site-warning-ma"
      v-if="isOK && listStatus[record.info.stationId]['mas'] > 0"
    >
      {{ $t('com_fault_ma') }}
      {{ listStatus[record.info.stationId]['mas'] }}
    </span>
    <span
      class="site-warning site-warning-qa"
      v-if="isOK && listStatus[record.info.stationId]['oas'] > 0"
    >
      {{ $t('com_fault_oa') }}
      {{ listStatus[record.info.stationId]['oas'] }}
    </span>
  </div>
</template>
<script>
export default {
  props: {
    record: {
      type: Object,
      required: true,
    },
    listStatus: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isOK() {
      return this.listStatus && this.listStatus[this.record.info.stationId];
    },
  },
};
</script>
<style lang="less" scoped>
.site-warning {
  height: 22px;
  line-height: 22px;
  padding: 0 4px;
  border-radius: 4px;
  font-size: 12px;
  margin-right: 8px;
  white-space: nowrap;
  margin-bottom: 5px;
  // all
  &.site-warning-all {
    border: 1px solid #e6e7f8;
    background: #f9f9fd;
    color: #1838d9;
  }
  // CA
  &.site-warning-ca {
    color: #f5222d;
    border: 1px solid #ffccc7;
    background: #fff1f0;
  }
  // MA
  &.site-warning-ma {
    color: #faad14;
    border: 1px solid #fff1b8;
    background: #fffbe6;
  }
  // QA
  &.site-warning-qa {
    color: #13c2c2;
    border: 1px solid #b5f5ec;
    background: #e6fffb;
  }
}
</style>
